import { base, type IIconProps } from './base';

export function FilePdfIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
      <rect x="6.5" y="13" width="11" height="6" rx="1.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function FileSheetIcon({ size = 16 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M3 9h18" />
      <path d="M3 15h18" />
      <path d="M9 3v18" />
    </svg>
  );
}